import React from 'react';
const OBLIGATIONS = [['01 · disclosure.safety', 'v3.2 · fired'], ['02 · claims.no-guarantee', 'v3.2 · fired'], ['03 · format.hcp-letter', 'v1.9 · fired'], ['04 · language.approved-only', 'v4.1 · fired'], ['05 · review.medical-legal', 'v2.0 · fired'], ['06 · retention.audit-trail', 'v1.4 · fired'], ['07 · house.med-info-voice', 'v2.3 · fired']];
const sectionStyle: React.CSSProperties = {
  fontFamily: 'var(--disp)',
  fontWeight: 600,
  color: '#0F5480',
  fontSize: 12,
  letterSpacing: '.04em',
  margin: '4px 0 6px'
};

/** The signed payload receipt: what fired, which version, on what trigger. */
export function ReceiptCard() {
  return <div className="mcard" style={{
    maxWidth: 430,
    margin: '0 auto',
    fontSize: '11.5px'
  }} data-id="element-143" data-mp="1tkm1676r5f8s">
      <div className="h" data-id="element-144" data-mp="1yj5ooc0zuz39">
        <span className="s" data-id="element-145" data-mp="1joiwouofh4io">/ PAYLOAD RECEIPT</span>
        <span className="s2" data-id="element-146" data-mp="1jp14mokgd76f">#cr-7842</span>
      </div>
      <div className="b" data-id="element-147" data-mp="1onvozuy2j3sn">
        <div className="r" data-id="element-148" data-mp="1om11q9zbqzle">
          <span data-id="element-149" data-mp="1opgeh65izwjn">workflow</span>
          <span className="v" data-id="element-150" data-mp="2bd9a4d04u28u">claim.review &middot; pharma</span>
        </div>
        <div className="r" data-id="element-151" data-mp="2bfc8bkbfv1on">
          <span data-id="element-152" data-mp="26exybwqa1hnz">trigger matched</span>
          <span className="v" data-id="element-153" data-mp="26dwizg28a90g">performance language</span>
        </div>
        <div className="r" data-id="element-154" data-mp="2keh62of6eqzr">
          <span data-id="element-155" data-mp="2kdnw7ekx7lde">passes</span>
          <span className="v" data-id="element-156" data-mp="2kbuxqmkgo7gh">1 &middot; approved first pass</span>
        </div>

        <div className="dv" data-id="element-157" data-mp="2gdds67gov516" />
        <div style={sectionStyle} data-id="element-158" data-mp="1smrth6skqx3u">OBLIGATIONS &middot; 7/7 FIRED</div>
        {OBLIGATIONS.map(([name, state]) => <div className="r" key={name} data-id="element-159" data-mp="1noggwoawa8hx">
            <span data-id="element-160" data-mp="1nprnswzmzwd9">{name}</span>
            <span className="v g" data-id="element-161" data-mp="21fblhoed23fp">{state}</span>
          </div>)}

        <div className="dv" data-id="element-162" data-mp="21gmqtsngfj8x" />
        <div style={sectionStyle} data-id="element-163" data-mp="1wov6w0yt0brr">SIGNATURE</div>
        <div className="r" data-id="element-164" data-mp="1wn1yag4mrhh4">
          <span data-id="element-165" data-mp="1wms6qo3xt29b">algorithm</span>
          <span className="v" data-id="element-166" data-mp="18yiotx9ugyng">ed25519</span>
        </div>
        <div className="r" data-id="element-167" data-mp="18wxuo8rfzhq4">
          <span data-id="element-168" data-mp="14xp1p6487nvm">digest</span>
          <span className="v" data-id="element-169" data-mp="14wdz39miom63">9f3a71&hellip;d41c</span>
        </div>
        <div className="r" data-id="element-170" data-mp="342gqxfq1p0qt">
          <span data-id="element-171" data-mp="3415njh0ihv08">2026-09-05 &middot; 14:02:11 UTC</span>
          <span className="v g" data-id="element-172" data-mp="340cn0xs5c1qj">SIGNED</span>
        </div>
      </div>
    </div>;
}